import React from 'react';
import ProductVerificationForm from './components/ProductVerificationForm';

const ProductVerification = () => {
  return <ProductVerificationForm />;
};

export default ProductVerification;
